module.exports = __webpack_public_path__ + "static/img/selected.91c3a4ca.svg";